/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Registration_Confirm_RejectInputs */

const en_admin_registration_confirm_reject = /** @type {(inputs: Admin_Registration_Confirm_RejectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reject this registration?`)
};

const de_admin_registration_confirm_reject = /** @type {(inputs: Admin_Registration_Confirm_RejectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registrierung wirklich ablehnen?`)
};

/**
* | output |
* | --- |
* | "Reject this registration?" |
*
* @param {Admin_Registration_Confirm_RejectInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_registration_confirm_reject = /** @type {((inputs?: Admin_Registration_Confirm_RejectInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Registration_Confirm_RejectInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_registration_confirm_reject(inputs)
	return en_admin_registration_confirm_reject(inputs)
});